
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Series } from "@/types/series";

export function useSeriesList() {
  return useQuery({
    queryKey: ["series-list"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("series")
        .select(`
          *,
          videos:videos(count),
          audios:audios(count)
        `)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching series:", error);
        throw error;
      }

      return data.map((item: any) => ({
        ...item,
        video_count: (item.videos[0]?.count || 0) + (item.audios[0]?.count || 0)
      })) as Series[];
    },
  });
}

export function useSeries(id: string) {
  return useQuery({
    queryKey: ["series", id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("series")
        .select("*")
        .eq("id", id)
        .single();

      if (error) {
        console.error("Error fetching series details:", error);
        throw error;
      }

      return data as Series;
    },
    enabled: !!id,
  });
}
